module.exports = __webpack_public_path__ + "img/uk_Ecran 2.679042bf.png";